let _Math = require("../lib/Math");
let Utils = require("../lib/Utils");

class Plot extends React.Component {
  scaleX(domainX, typeX, insetX, width, margin) {
    let scale = d3.scaleLinear;
    let x0 = insetX;
    let x1 = width - margin.left - margin.right - insetX;
    let range = [x0, x1];

    if (typeX === "UTC") {
      scale = d3.scaleUtc;
    }

    if (typeX === "ordinal") {
      let step = (x1 - x0) / domainX.length;

      range = domainX.map((d, i) => x0 + (step / 2) + (step * i));
      scale = d3.scaleOrdinal;
    }

    return scale()
      .domain(domainX)
      .range(range);
  }

  scaleY(domainY, typeY, insetY, height, margin) {
    let scale = d3.scaleLinear;
    let y0 = height - margin.top - margin.bottom;
    let y1 = margin.top;
    let range = [y0, y1];

    if (typeY === "ordinal") {
      let step = (y0 - y1) / domainY.length;

      range = domainY.map((d, i) => y1 + (step / 2) + (step * i));
      scale = d3.scaleOrdinal;
    }

    return scale()
      .domain(domainY)
      .range(range);
  }

  inferDomain(data, domain, type, step, accessor, zeroFloor) {
    if (type === "ordinal") {
      return domain || Utils.distinct(data.map(accessor));
    }

    let [a, b] = domain || (zeroFloor ? [0, d3.max(data, accessor)] : d3.extent(data, accessor));

    let steps = [[0.1, 0.2, 0.5], [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000]];

    let ticks = _Math.ticks(a || 0, b || 1, step || (b - a <= 1 ? steps[0] : steps[1]), 10);

    let extent = d3.extent(ticks);

    if (type === "linear") {
      extent.ticks = ticks;
    }

    return extent;
  }

  render() {
    let {
      children,
      id,
      width,
      height,
      margin,
      background,
      data,
      domainX,
      domainY,
      getX,
      getY,
      formatX,
      formatY,
      typeX,
      typeY,
      stepX,
      stepY,
      insetX
    } = this.props;

    let x = margin.left;
    let y = margin.top;
    let w = width - margin.left - margin.right;
    let h = height - margin.top - margin.bottom;

    let _domainX = this.inferDomain(data, domainX, typeX, stepX, getX, false);
    let _domainY = this.inferDomain(data, domainY, typeY, stepY, getY, true);
    let scaleX = this.scaleX(_domainX, typeX, insetX, width, margin);
    let scaleY = this.scaleY(_domainY, typeY, null, height, margin);

    return (
      <svg width={width} height={height} className="mc-plot" id={id}>
        <g transform={`translate(${x},${y})`}>
          <rect width={w} height={h} fill={background}/>
          {React.Children.map(children, (child, i) => {
            if (child.props.visible === false) {
              return null;
            }

            let _getY = child.props.getY || getY;

            let isDefined = (d) => {
              let y = _getY(d);

              return y !== null && y !== undefined;
            };

            let elem = React.cloneElement(child, {
              data: child.props.filter === false ? data : data.filter(isDefined),
              width: w,
              height: h,
              margin,
              scaleX,
              scaleY,
              getX,
              getY: _getY,
              formatX,
              formatY,
              domainX: _domainX,
              domainY: _domainY,
              typeX,
              typeY,
              stepY,
              insetX: Math.max(5, insetX)
            });

            return elem;
          })}
        </g>
      </svg>
    );
  }
}

Plot.defaultProps = {
  id: null,
  width: 800,
  height: 300,
  margin: { top: 10, right: 10, bottom: 50, left: 60 },
  background: "#fff",
  data: [],
  domainX: null,
  domainY: null,
  insetX: 10,
  getX: (x, i) => i,
  getY: (y) => y,
  formatX: null,
  formatY: null,
  typeX: "linear",
  typeY: "linear",
  stepX: null,
  stepY: null
};

module.exports = Plot;